var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20/edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6552 6.35382L10.2553 3.94104L11.0142 3.18207C11.2279 2.96841 11.4805 2.86157 11.7719 2.86157C12.0633 2.86157 12.3159 2.96841 12.5296 3.18207L13.4206 4.07309C13.6232 4.27564 13.7223 4.53034 13.718 4.83717C13.7137 5.14401 13.6103 5.3987 13.4078 5.60126L12.6552 6.35382ZM11.9155 7.08714L4.83599 14.1666H2.43604V11.7667L9.51552 4.68717L11.9155 7.08714Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.70ffab8a6801a9c15aee9d921c030fe5.svg";
export { ForwardRef as ReactComponent };